import React, { useContext, useEffect, useLayoutEffect } from 'react';
import UFOInteractionContext from '../interaction-context';
var useLayoutEffectSAFE = typeof window === 'undefined' ? useEffect : useLayoutEffect;

/**
 * Render this whenever you're loading.
 *
 * Wrap loading elements
 * ```js
 * if (isLoading){
 *   return (
 *     <UFOLoadHold name="card">
 *       <Skeleton />
 *     </UFOLoadHold>
 *   )
 * }
 * ```
 *
 * Or render it as a sibling
 * ```
 * if (isLoading){
 *   return (
 *     <>
 *       <Skeleton />
 *       <UFOLoadHold name="card">
 *     </UFOLoadHold>
 *   )
 * }
 * ```
 *
 * Or wrap your content conditionally
 * ```
 * return (
 *   <UFOLoadHold name="card" hold={isLoading}>
 *     <Card />
 *   </UFOLoadHold>
 * )
 * ```
 *
 * Or render as a sibling conditionally
 * ```
 * return (
 *   <>
 *     <Card />
 *     <UFOLoadHold name="card" hold={isLoading} />
 *   </>
 * )
 * ```
 */

export default function UFOLoadHold(_ref) {
  var children = _ref.children,
    name = _ref.name,
    _ref$hold = _ref.hold,
    hold = _ref$hold === void 0 ? true : _ref$hold;
  // react-18: useId instead
  var context = useContext(UFOInteractionContext);
  useLayoutEffectSAFE(function () {
    if (hold && context != null) {
      return context.hold(name);
    }
  }, [hold, context, name]);

  // react-18: can return children directly
  return children != null ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
}